// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productPrimaryImageStyles } from "@sc/Overrides/Components/ProductPrimaryImage";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: auto;
            max-width: 100%;
        }
    `,
};
productPrimaryImageStyles.zoomBtn = {
    css: css`
        position: absolute;
        bottom: 12px;
        right: 12px;
        z-index: 1;
        padding: 0;
        height: 21px;
        width: 20px;
        &&&& ${IconWrapper}, &&&& svg {
            height: 21px;
            width: 20px;
            color: ${color("text.link")};
        }
    `,
};
productPrimaryImageStyles.container = {
    css: css`
        position: relative;
    `,
};